import {lazy} from 'react';

export const PollLazy = lazy(() => import(/* webpackChunkName: "poll" */ '.'));
